<template>
	<div>
		<h1>{{ $t('settings') }}</h1>

		<!-- General -->
		<div class="list-group border-radius-2 no-border mb-3">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('general') }}</h2></div>
			<router-link to="/settings/general" class="list-group-item">{{ $t('general-settings') }}</router-link>
			<a href="#" @click.prevent="updateApp()" class="list-group-item">{{ $t('update-app') }}</a>
			<router-link to="/settings/retryrequests" class="list-group-item">{{ $t('retry-requests') }}</router-link>
		</div>

		<!-- Tags -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('MANAGE_TAGS')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('configuration') }}</h2></div>
			<router-link to="/settings/tagmanager" class="list-group-item" v-if="hasPriv('MANAGE_TAGS')">{{ $t('tag-manager') }}</router-link>
			<router-link to="/settings/taggroups" class="list-group-item" v-if="hasPriv('MANAGE_TAGS')">{{  $t('tag-groups') }}</router-link>
		</div>

		<!-- Users & Roles -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('USER_MANAGE')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('users') }}</h2></div>
			<router-link to="/settings/users" class="list-group-item">{{ $t('manage-users') }}</router-link>
			<router-link to="/settings/users/roles" class="list-group-item">{{ $t('manage-roles') }}</router-link>
			<router-link to="/settings/grouptypes" class="list-group-item">{{ $t('student-groups') }}</router-link>
		</div>

		<!-- Compentency Tests -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('COMPTEST_MANAGE')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('tests') }}</h2></div>
			<router-link to="/settings/competencytests" class="list-group-item">{{ $t('tests') }}</router-link>
			<router-link to="/settings/competencytests/filters" class="list-group-item">{{ $t('test-filters') }}</router-link>
		</div>

		<!-- Third Party Data -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('THIRDPARTYDATA_MANAGE')||hasPriv('REPORTDATAELEMENTEDITOR')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('reports') }}</h2></div>
			<router-link to="/settings/reports/dataelements" class="list-group-item"  v-if="hasPriv('REPORTDATAELEMENTEDITOR')">{{ $t('report-data-elements') }}</router-link>
			<router-link to="/settings/reports/config" class="list-group-item"  v-if="hasPriv('REPORTDATAELEMENTEDITOR')">{{ $t('report-editor') }}</router-link>
			<router-link to="/thirdparty/edit" class="list-group-item"  v-if="hasPriv('THIRDPARTYDATA_MANAGE')">{{ $t('third-party-data') }}</router-link>
		</div>

		<!-- Forms -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('EDIT_FORMS')||hasPriv('MANAGE_WORKBOOKS')">
			<!--<router-link to="/formeditor/home" class="list-group-item">
				<h2 class="mb-0 mt-0 pt-0 pb-0">
					<b-icon icon="chevron-right" class="float-right pt-1"></b-icon>
					{{ $t('forms') }}
				</h2>
			</router-link>-->
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('forms') }}</h2></div>
			<template v-if="hasPriv('EDIT_FORMS')">
				<router-link to="/formeditor/forms" class="list-group-item">{{ $t('forms') }}</router-link>
				<router-link to="/settings/workflows" class="list-group-item">{{ $t('workflows') }}</router-link>
				<router-link to="/formeditor/formlibrary/field" class="list-group-item">{{ $t('form-library-fields') }}</router-link>
				<router-link to="/formeditor/formlibrary/selectoptions" class="list-group-item">{{ $t('form-library-options') }}</router-link>
				<!--<router-link to="/formeditor/formschedules" class="list-group-item">{{ $t('form-schedules') }}</router-link>-->
			</template>
			<router-link to="/settings/workbooks" class="list-group-item" v-if="hasPriv('MANAGE_WORKBOOKS')">{{ $t('workbooks') }}</router-link>
		</div>

		<!-- Interfaces -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('APPINTERFACE_MANAGE')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('clinical-interface') }}</h2></div>
			<router-link to="/settings/interfaceeditor/procedures" class="list-group-item">{{ $t('procedures') }}</router-link>
			<router-link to="/settings/interfaceeditor/sections" class="list-group-item">{{ $t('sections') }}</router-link>
		</div>

		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('CURRICULUMMAP_MANAGE')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('curriculum-mapping') }}</h2></div>
			<router-link to="/curriculum-mapping" class="list-group-item">{{ $t('curriculum-mapping') }}</router-link>
			<router-link to="/curriculum-mapping/learning-outcomes" class="list-group-item">{{ $t('learning-outcomes') }}</router-link>
			<router-link to="/curriculum-mapping/learning-outcomes/unmapped" class="list-group-item">{{ $t('unmapped-learning-outcomes') }}</router-link>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	},
	data: function() {
		return {
			activeItem: null
		};
	},
	mounted() {

	},
	methods: {
		hasPriv(priv) {
			return this.$UserSession.hasPriv.call(this, priv);
		},
		updateApp: function() {
			location.reload();
		},
		updateApp2: function() {
			window.location.reload(true);
		},
		testMessageNotification: function() {
			this.$bvToast.toast(`Lorem ipsum dolor sit amet...`, {
				title: "New Message",
				autoHideDelay: 5000
			});

			this.$store.commit("increaseUnread");
		}
	},
	computed: {
		canManageTags() {
			return this.$UserSession.hasPriv.call(this, "MANAGE_TAGS")
		}
	}
};
</script>
